export default __webpack_public_path__ + "static/media/SPLFWhiteNew.69ba4414.svg";